import { Link } from 'react-router-dom';
import { useDomain } from '@/hooks/useDomain';

const Header = () => {
  const { domain, isLoading } = useDomain();

  if (isLoading) return null;
  if (!domain) return <div>Domain not found</div>;

  return (
    <header className="bg-[rgb(var(--bg-primary))] border-b border-[rgb(var(--border))]">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/">
            {domain.logo_path ? (
              <img 
                src={domain.logo_path} 
                alt={`${domain.name} logo`} 
                className="h-16 w-auto"
              />
            ) : (
              <div 
                className="h-16 w-16 rounded-full flex items-center justify-center text-white"
                style={{ backgroundColor: domain.theme.primaryColor }}
              >
                {domain.name.charAt(0)}
              </div>
            )}
          </Link>
          
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="font-medium text-[rgb(var(--text-secondary))] hover:text-[rgb(var(--text-primary))]">
              Home
            </Link>
            <Link to="/categories/wellness" className="font-medium text-[rgb(var(--text-secondary))] hover:text-[rgb(var(--text-primary))]">
              Wellness
            </Link>
            <Link to="/categories/health" className="font-medium text-[rgb(var(--text-secondary))] hover:text-[rgb(var(--text-primary))]">
              Health
            </Link>
            <Link to="/categories/lifestyle" className="font-medium text-[rgb(var(--text-secondary))] hover:text-[rgb(var(--text-primary))]">
              Lifestyle
            </Link>
            <Link to="/about" className="font-medium text-[rgb(var(--text-secondary))] hover:text-[rgb(var(--text-primary))]">
              About
            </Link>
          </nav>
          
          <div className="md:hidden">
            {/* Mobile menu button - simplified for this implementation */}
            <button className="text-[rgb(var(--text-primary))]">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 